export const FILE_UPLOAD_CLASS_NAME = 'file-upload'
